export * from './ShapeCircleMsIcon';
export * from './ShapeCircleMsIcon16Light';
export * from './ShapeCircleMsIcon16Regular';
export * from './ShapeCircleMsIcon16Solid';
export * from './ShapeCircleMsIcon20Light';
export * from './ShapeCircleMsIcon20Regular';
export * from './ShapeCircleMsIcon20Solid';
export * from './ShapeCircleMsIcon24Regular';
export * from './ShapeCircleMsIcon24Solid';
export * from './ShapeCircleMsIcon32Regular';
export * from './ShapeCircleMsIcon64Regular';
